import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeCodeState } from '~/types';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

type TypeRegisterWorkPlanParams = {
  cluster: string;
  center: string;
  workPart: string;
  workDate: string;
  workShift: string;
  requestReason: string;
};

type TypeRegisterWorkPlanResponse = {
  code: string;
  message: string;
  data: {
    id: number;
    status: TypeCodeState;
    cluster: string;
    center: string;
    workPart: string;
    workDate: string;
    workShift: {
      startTime: string;
      endTime: string;
      isStartTimeBeforeEndTime: boolean;
      formattedText: string;
    };
    requestReason: string;
    requestedAt: string;
  };
};

/**
 * @description (상용직) 나의 근무 > 사후 근무 등록 api에 사용되는 커스텀 훅
 */
export const useRegisterWorkPlan = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeRegisterWorkPlanParams) => {
      const endpoint = '/work-plan-registration-requests';
      return axiosInstance.post(endpoint, params);
    },
  });

  const requestRegisterWorkPlan = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeRegisterWorkPlanParams;
    onSuccess?: (res: TypeRegisterWorkPlanResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError);
  };

  return requestRegisterWorkPlan;
};
